export default "__VITE_ASSET__Cd76N7V9__"